// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mainContent[data-v-64ffd906]{margin:0 auto}.btBox[data-v-64ffd906]{margin-bottom:0}", ""]);
// Exports
module.exports = exports;
